/**
 * Mega menu hover interactions (POP-ONLY)
 * - Menus: Pottery, Glassware, Misc, Sale (+ static "More")
 * - Features:
 *   • Separate, easy-to-edit delays for main header open vs subcategory hover
 *   • Sequential 1→2→3 reveal (START_DELAY_MS / STEP_MS) for BOTH presets & showcases
 *   • Purposeful pop animation (card + image) every time — no "load" image flipping
 *   • Presets animate on every open (and when falling back)
 *   • Handles empty collections + data-show-preset="true"
 *   • Preloads images quietly in the background
 */

document.addEventListener('DOMContentLoaded', function () {
  const isDesktop = () => window.innerWidth >= 1024;

  // ===== Timing knobs =====
  const MENU_OPEN_INTENT_MS = 70;  // main header open delay
  const HOVER_INTENT_MS     = 70;  // subcategory hover delay
  const START_DELAY_MS      = 50;  // first card delay
  const STEP_MS             = 30;  // cadence

  const PRESET_SEQUENTIAL_IMG_FLIP = false; // pop-only behavior

  // ===== Desktop open/close of header menus =====
  document.querySelectorAll('details.header__megamenu-item').forEach((details) => {
    const summary = details.querySelector('summary');
    const submenu = details.querySelector('.header__submenu');
    if (!summary || !submenu) return;

    let hoverTimeout;
    let openAnimTimer;

    summary.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(hoverTimeout);
      clearTimeout(openAnimTimer);

      details.setAttribute('open', true);

      // Preload once when a header first opens
      if (!details.__preloaded) {
        details.__preloaded = true;
        submenu.querySelectorAll('[class*="mega-menu-"]').forEach((root) => {
          const ns = detectNS(root);
          const fn = window[`__preload${capitalize(ns)}Showcase`];
          fn && fn();
        });
      }

      // FIX 1: DO NOT stage presets immediately. Staging hides cards (visibility:hidden)
      // and if the user moves fast you get a blank grid. We only stage right before animating.

      // Apply MAIN HEADER delay here (header-only)
      openAnimTimer = setTimeout(() => {
        // Now that we will animate, stage + animate presets
        submenu.querySelectorAll('[id$="-preset"]').forEach((preset) => {
          stageCardsPending(preset);      // moved here
          animatePresetCards(preset);
        });
        // Animate the "More" menu grid too
        submenu.querySelectorAll('.mega-menu-more').forEach((moreRoot) => {
          stageCardsPending(moreRoot);    // moved here
          animateCardsIn(moreRoot, START_DELAY_MS, STEP_MS);
        });
      }, MENU_OPEN_INTENT_MS);
    });

    submenu.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      clearTimeout(hoverTimeout);
    });

    details.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      clearTimeout(openAnimTimer);
      hoverTimeout = setTimeout(() => {
        details.removeAttribute('open');
        // Restore presets for any menus inside this submenu (no animation on close)
        submenu.querySelectorAll('[class*="mega-menu-"]').forEach((root) => {
          const ns = detectNS(root);
          const fn = window[`__${ns}ShowPreset`];
          fn && fn(false);
        });
      }, 150);
    });

    // Don’t toggle with click on desktop
    summary.addEventListener('click', (e) => { if (isDesktop()) e.preventDefault(); });
  });

  // ===== Auto-init dynamic mega menus =====
  document
    .querySelectorAll('.mega-menu-talavera, .mega-menu-glassware, .mega-menu-miscellaneous, .mega-menu-sale')
    .forEach(setupMenu);

  // Proactively preload/decoded all menu images on page load so first-hover has zero "load-in"
  setTimeout(() => {
    document
      .querySelectorAll('.mega-menu-talavera, .mega-menu-glassware, .mega-menu-miscellaneous, .mega-menu-sale')
      .forEach((root) => {
        const ns = detectNS(root);
        const fn = window[`__preload${capitalize(ns)}Showcase`];
        fn && fn();
      });
  }, 0);

  // ---------- helpers ----------
  function detectNS(root) {
    if (root.classList.contains('mega-menu-talavera')) return 'pottery';
    if (root.classList.contains('mega-menu-glassware')) return 'glassware';
    if (root.classList.contains('mega-menu-miscellaneous')) return 'misc';
    if (root.classList.contains('mega-menu-sale')) return 'sale';
    if (root.classList.contains('mega-menu-more')) return 'more';
    return 'menu';
  }
  function capitalize(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  // Restart animations reliably (card + image) — POP ONLY
  function restartAnimation(card) {
    card.classList.remove('reveal');
    card.style.animation = 'none';
    void card.offsetWidth; // paint flush
    card.style.animation = '';
    card.classList.add('reveal');

    const img = card.querySelector('.mega-media img');
    if (img) {
      img.style.animation = 'none';
      void img.offsetWidth;
      img.style.animation = '';
    }
  }

  // Put all cards in a container into "pending" (hidden) — POP ONLY (no src flip)
  function stageCardsPending(container) {
    const cards = Array.from(container.querySelectorAll('.mega-card'));
    cards.forEach((card) => {
      card.style.visibility = 'hidden';
      card.classList.remove('reveal');
      card.classList.add('pending');
    });
  }

  function animateCardsIn(container, startDelay = START_DELAY_MS, step = STEP_MS) {
    const cards = Array.from(container.querySelectorAll('.mega-card'));
    if (!cards.length) return;

    // Stage if not already
    cards.forEach((card) => {
      if (!card.classList.contains('pending')) {
        card.style.visibility = 'hidden';
        card.classList.remove('reveal');
        card.classList.add('pending');
      }
    });

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        cards.forEach((card, idx) => {
          setTimeout(() => {
            card.style.visibility = 'visible';
            card.classList.remove('pending');
            restartAnimation(card);
          }, startDelay + idx * step);
        });
      });
    });
  }

  function animatePresetCards(presetContainer) {
    if (!presetContainer) return;
    animateCardsIn(presetContainer, START_DELAY_MS, STEP_MS);
  }

  // ---------- per-menu setup (dynamic menus) ----------
  function setupMenu(root) {
    const preset   = root.querySelector('[id$="-preset"]');
    const showcase = root.querySelector('[id$="-showcase"]');
    if (!preset || !showcase) return;

    // Links that drive swaps
    const links = Array.from(
      root.querySelectorAll('.mega-collection-link[data-collection-handle], .mega-collection-link[data-show-preset="true"]')
    );
    if (!links.length) return;

    const ns = detectNS(root);

    // Show/Hide with overlap support
    function showPreset(animate = false) {
      // Make preset visible
      preset.classList.remove('is-hidden');
      preset.setAttribute('aria-hidden', 'false');

      // Only after preset is visible, hide showcase
      showcase.classList.remove('is-live');
      showcase.setAttribute('aria-hidden', 'true');

      // Reset showcase cards
      showcase.querySelectorAll('.mega-card').forEach((card) => {
        card.classList.remove('reveal', 'pending');
        card.style.visibility = 'hidden';
        const img = card.querySelector('img'); const t = card.querySelector('.mega-card-title');
        if (t) t.textContent = '';
        card.removeAttribute('href');
        card.removeAttribute('title');
               card.removeAttribute('aria-label');
        // (We do not clear img src in pop-only logic)
      });
      links.forEach(l => l.classList.remove('is-active'));

      if (animate) {
        stageCardsPending(preset);
        animatePresetCards(preset);
      }
    }

    // NOTE: we won’t hide the preset here; we do it *after* the first showcase card becomes visible
    function showShowcaseOverlapStart() {
      showcase.classList.add('is-live');
      showcase.setAttribute('aria-hidden', 'false');
    }
    function hidePresetAfterFirstReveal() {
      preset.classList.add('is-hidden');
      preset.setAttribute('aria-hidden', 'true');
    }

    // Expose for header close + preloader
    window[`__${ns}ShowPreset`] = showPreset;

    // ---- Data access ----
    function parseCollectionData(handle) {
      const el = root.querySelector(`.mega-collection-data[data-handle="${handle}"]`)
             || document.querySelector(`.mega-collection-data[data-handle="${handle}"]`);
      if (!el) return null;
      try {
        const items = JSON.parse((el.textContent || '').trim() || '[]');
        return {
          items,
          url:   el.getAttribute('data-collection-url'),
          title: el.getAttribute('data-collection-title')
        };
      } catch (e) { return null; }
    }

    // ---- Preload images (network + decode to eliminate first-hover load-in) ----
    const preloadCache = new Map();
    function loadImage(url) {
      return new Promise((resolve) => {
        if (!url) return resolve(null);
        const img = new Image();
        img.decoding = 'async';
        img.fetchPriority = 'low';
        img.onload = async () => {
          // Ensure the bitmap is decoded before we ever swap it in
          try { if (img.decode) await img.decode(); } catch(_) {}
          resolve(img);
        };
        img.onerror = () => resolve(img);
        img.src = url;
      });
    }
    function preloadCollection(handle) {
      if (preloadCache.has(handle)) return preloadCache.get(handle);
      const data = parseCollectionData(handle);
      if (!data) return Promise.resolve(null);
      const p = Promise.all((data.items || []).slice(0,3).map(i => loadImage(i.image)))
                .then(imgs => ({ imgs, data }));
      preloadCache.set(handle, p);
      return p;
    }
    function preloadMany(handles, maxConcurrent = 3) {
      let i = 0, active = 0;
      return new Promise(resolve => {
        const next = () => {
          while (active < maxConcurrent && i < handles.length) {
            const h = handles[i++]; active++;
            preloadCollection(h).finally(() => { active--; next(); });
          }
          if (active === 0 && i >= handles.length) resolve();
        };
        next();
      });
    }
    window[`__preload${capitalize(ns)}Showcase`] = () => {
      const handles = links.map(l => l.getAttribute('data-collection-handle')).filter(Boolean);
      preloadMany(handles, 3);
    };

    // ---- Sequential swap with guaranteed pop every time (no img flipping) ----
    let intentTimer = null;
    let currentToken = 0; // cancels in-flight sequences on fast movement

    function setImgSrc(imgTag, newSrc) {
      if (!newSrc) return;
      // Ensure eager paint on first-use even if the HTML had loading="lazy"
      if (imgTag.getAttribute('loading') === 'lazy') imgTag.removeAttribute('loading');
      try { imgTag.fetchPriority = 'high'; } catch(_) {}
      if (imgTag.src !== newSrc) imgTag.src = newSrc;
      imgTag.decoding = 'async';
    }

    function sequentialSwap(preloaded, token) {
      if (!preloaded || token !== currentToken) return;

      const { imgs, data } = preloaded;
      const linkTo  = showcase.getAttribute('data-linkto') || 'product';
      const viewAll = showcase.querySelector('.mega-viewall');
      const cards   = showcase.querySelectorAll('.mega-card');

      // Stage showcase cards now
      stageCardsPending(showcase);

      if (viewAll) {
        if (data.url) {
          viewAll.href = data.url;
          viewAll.style.display = 'inline-flex';
          viewAll.textContent = 'View all ' + (data.title || '');
        } else {
          viewAll.style.display = 'none';
        }
      }

      // Start overlap: make showcase live, but DO NOT hide preset yet
      showShowcaseOverlapStart();

      // Ensure "pending" paints before reveal
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          (data.items || []).slice(0, 3).forEach((item, idx) => {
            setTimeout(() => {
              if (token !== currentToken) return;

              const card    = cards[idx];
              const imgTag  = card.querySelector('img');
              const titleEl = card.querySelector('.mega-card-title');

              const t = item.title || '';
              if (titleEl) titleEl.textContent = t;
              if (imgTag) {
                imgTag.alt = t;
                const pre = (imgs && imgs[idx] && imgs[idx].src) ? imgs[idx].src : null;
                const src = pre || item.image || '';
                setImgSrc(imgTag, src);
              }

              if (linkTo === 'product' && item.url) card.href = item.url;
              else if (data.url)                    card.href = data.url;
              else                                  card.removeAttribute('href');

              card.title = t;
              card.setAttribute('aria-label', t);

              // Reveal this card
              card.style.visibility = 'visible';
              card.classList.remove('pending');
              restartAnimation(card);

              // FIX 2: hide preset only after the FIRST card is visible
              if (idx === 0) hidePresetAfterFirstReveal();

            }, START_DELAY_MS + idx * STEP_MS);
          });

          // Hide any unused cards
          for (let i = (data.items || []).length; i < cards.length; i++) {
            const card = cards[i];
            card.style.visibility = 'hidden';
            card.classList.remove('pending', 'reveal');
          }
        });
      });
    }

    function setActive(linkEl) {
      links.forEach(l => l.classList.remove('is-active'));
      linkEl && linkEl.classList.add('is-active');
    }

    links.forEach((link) => {
      link.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;

        const handle = link.getAttribute('data-collection-handle');
        const wantsPreset = link.getAttribute('data-show-preset') === 'true';
        setActive(link);

        if (!wantsPreset && handle) preloadCollection(handle);

        clearTimeout(intentTimer);
        const myToken = ++currentToken;

        intentTimer = setTimeout(() => {
          if (myToken !== currentToken) return;

          if (wantsPreset || !handle) {
            showPreset(true); // animate preset using same timings
            return;
          }

          const data = parseCollectionData(handle);
          if (!data || !data.items || data.items.length === 0) {
            showPreset(true);
            return;
          }

          // NOTE: preset remains visible for overlap; showcase is made live in sequentialSwap
          preloadCollection(handle).then((preloaded) => sequentialSwap(preloaded, myToken));
        }, HOVER_INTENT_MS);
      });
    });

    // default state (we animate presets on menu open, not here)
    showPreset(false);
  }
});
